// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Check, Pencil, Trash2 } from "lucide-react";

// const CourseManagement = () => {
//   const [formData, setFormData] = useState({
//     CourseID: "",
//     CourseName: "",
//     CourseTypeID: [],
//     duration: { value: 0, unit: "Months" },
//     payment: { single: 0, installment: 0 },
//   });

//   const [allCourseTypes, setAllCourseTypes] = useState([]);
//   const [courses, setCourses] = useState([]);
//   const [isEdit, setIsEdit] = useState(false);
//   const [editingCourseId, setEditingCourseId] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;

//   useEffect(() => {
//     axios.get("/api/coursetypes")
//       .then(res => setAllCourseTypes(res.data || []))
//       .catch(err => console.error(err));

//     axios.get("/api/courses")
//       .then(res => setCourses(res.data || []))
//       .catch(err => console.error(err));
//   }, []);

//   // const handleCourseTypeSelect = (e) => {
//   //   const selected = Array.from(e.target.selectedOptions, option => option.value);
//   //   setFormData(prev => ({ ...prev, CourseTypeID: selected }));

//   //   if (selected.length > 0) {
//   //     const typeId = selected[0];
//   //     const typeObj = allCourseTypes.find(t => t._id === typeId);
//   //     const typeCode = typeObj?.CourseTypeId || "TYPE";

//   //     const used = courses.filter(course =>
//   //       course.CourseTypeID.includes(typeId)
//   //     ).length;

//   //     const newID = `${typeCode}-${String(used + 1).padStart(3, "0")}`;
//   //     setFormData(prev => ({ ...prev, CourseID: newID }));
//   //   } else {
//   //     setFormData(prev => ({ ...prev, CourseID: "" }));
//   //   }
//   // };
// const handleCourseTypeSelect = async (e) => {
//   const selected = Array.from(e.target.selectedOptions, option => option.value);
//   setFormData(prev => ({ ...prev, CourseTypeID: selected }));

//   if (selected.length > 0) {
//     try {
//       const res = await axios.get(`/api/course/nextId/${selected[0]}`);
//       setFormData(prev => ({ ...prev, CourseID: res.data.nextId }));
//     } catch (err) {
//       console.error(err);
//     }
//   } else {
//     setFormData(prev => ({ ...prev, CourseID: "" }));
//   }
// };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name.includes(".")) {
//       const [parent, child] = name.split(".");
//       setFormData(prev => ({
//         ...prev,
//         [parent]: { ...prev[parent], [child]: value }
//       }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       CourseID: "",
//       CourseName: "",
//       CourseTypeID: [],
//       duration: { value: 0, unit: "Months" },
//       payment: { single: 0, installment: 0 },
//     });
//     setIsEdit(false);
//     setEditingCourseId(null);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (!isEdit) {
//         await axios.post("/api/course", formData);
//         alert("Course added successfully!");
//       } else {
//         await axios.put(`/api/course/${editingCourseId}`, formData);
//         alert("Course updated!");
//       }
//       resetForm();
//       const res = await axios.get("/api/courses");
//       setCourses(res.data || []);
//     } catch (err) {
//       console.error(err);
//       alert("Submit failed.");
//     }
//   };

//   const handleEdit = (course) => {
//     setFormData({
//       CourseID: course.CourseID,
//       CourseName: course.CourseName,
//       CourseTypeID: course.CourseTypeID.map(t => typeof t === "object" ? t._id : t),
//       duration: course.duration || { value: 0, unit: "Months" },
//       payment: course.payment || { single: 0, installment: 0 },
//     });
//     setIsEdit(true);
//     setEditingCourseId(course._id);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this course?")) return;
//     try {
//       await axios.delete(`/api/course/${id}`);
//       setCourses(prev => prev.filter(c => c._id !== id));
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const filteredCourses = courses.filter(c =>
//     c.CourseName.toLowerCase().includes(searchQuery.toLowerCase())
//   );
//   const totalPages = Math.ceil(filteredCourses.length / itemsPerPage);
//   const displayed = filteredCourses.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   return (
//     <div className="container mx-auto p-4">
//       <h3 className="text-xl font-semibold mb-4">{isEdit ? "Edit Course" : "Add Course"}</h3>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <input
//           type="text"
//           name="CourseID"
//           value={formData.CourseID}
//           readOnly
//           placeholder="Course ID"
//           className="w-full border px-3 py-2 rounded"
//         />

//         <select
//           multiple
//           name="CourseTypeID"
//           value={formData.CourseTypeID}
//           onChange={handleCourseTypeSelect}
//           className="w-full border px-3 py-2 rounded h-32"
//         >
//           {allCourseTypes.map(type => (
//             <option key={type._id} value={type._id}>
//               {type.CourseTypeName}
//             </option>
//           ))}
//         </select>

//         <input
//           type="text"
//           name="CourseName"
//           value={formData.CourseName}
//           onChange={handleChange}
//           placeholder="Course Name"
//           className="w-full border px-3 py-2 rounded"
//         />

//         <div className="flex gap-4">
//           <input
//             type="number"
//             name="duration.value"
//             value={formData.duration.value}
//             onChange={handleChange}
//             min={0}
//             placeholder="Duration"
//             className="border px-3 py-2 rounded"
//           />
//           <select
//             name="duration.unit"
//             value={formData.duration.unit}
//             onChange={handleChange}
//             className="border px-3 py-2 rounded"
//           >
//             <option value="Months">Months</option>
//             <option value="Days">Days</option>
//           </select>
//         </div>

//         <div className="flex gap-4">
//           <input
//             type="number"
//             name="payment.single"
//             value={formData.payment.single}
//             onChange={handleChange}
//             placeholder="Single Payment (₹)"
//             className="w-full border px-3 py-2 rounded"
//           />
//           <input
//             type="number"
//             name="payment.installment"
//             value={formData.payment.installment}
//             onChange={handleChange}
//             placeholder="Installment (₹)"
//             className="w-full border px-3 py-2 rounded"
//           />
//         </div>

//         <div>
//           <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
//             {isEdit ? "Update Course" : "Add Course"}
//           </button>
//           {isEdit && (
//             <button type="button" onClick={resetForm} className="ml-2 px-4 py-2 border rounded">
//               Cancel
//             </button>
//           )}
//         </div>
//       </form>

//       <input
//         type="text"
//         value={searchQuery}
//         onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//         placeholder="Search Courses"
//         className="w-full mt-6 border px-3 py-2 rounded"
//       />

//       <table className="table-auto w-full border mt-4">
//         <thead>
//           <tr className="bg-gray-100">
//             <th className="border px-2 py-1">Course ID</th>
//             <th className="border px-2 py-1">Name</th>
//             <th className="border px-2 py-1">Type(s)</th>
//             <th className="border px-2 py-1">Duration</th>
//             <th className="border px-2 py-1">Payment</th>
//             <th className="border px-2 py-1">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {displayed.map(course => (
//             <tr key={course._id}>
//               <td className="border px-2 py-1">{course.CourseID}</td>
//               <td className="border px-2 py-1">{course.CourseName}</td>
//             <td className="border px-2 py-1">
//   {course.CourseTypeID.map(type => type.CourseTypeName).join(", ")}
// </td>

//               <td className="border px-2 py-1">{course.duration?.value} {course.duration?.unit}</td>
//               <td className="border px-2 py-1">₹{course.payment?.single}, ₹{course.payment?.installment}</td>
//               <td className="border px-2 py-1 flex gap-2 justify-center">
//                 <button onClick={() => handleEdit(course)} className="text-blue-600">edit</button>
//                 <button onClick={() => handleDelete(course._id)} className="text-red-600">delete</button>
//               </td>
//             </tr>
//           ))}
//           {displayed.length === 0 && (
//             <tr><td colSpan={6} className="text-center py-4">No courses found.</td></tr>
//           )}
//         </tbody>
//       </table>

//       {totalPages > 1 && (
//         <div className="flex justify-center items-center gap-4 mt-4">
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="px-3 py-1 border rounded">
//             « Prev
//           </button>
//           <span>Page {currentPage} of {totalPages}</span>
//           <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} className="px-3 py-1 border rounded">
//             Next »
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CourseManagement;

import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseManagement = () => {
  const [formData, setFormData] = useState({
    CourseID: "",
    CourseName: "",
    CourseTypeID: [],
    duration: { value: 0, unit: "Months" },
    payment: { single: 0, installment: 0 },
  });

  const [allCourseTypes, setAllCourseTypes] = useState([]);
  const [courses, setCourses] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editingCourseId, setEditingCourseId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

 useEffect(() => {
  axios.get("/api/coursetypes")
    .then(res => setAllCourseTypes(res.data || []))
    .catch(err => console.error(err));

  axios.get("/api/new/courses")
    .then(res => {
      const validCourses = (res.data || []).filter(c => c && typeof c.CourseName === 'string');
      setCourses(validCourses);
    })
    .catch(err => console.error(err));
}, []);

  const handleCourseTypeSelect = async (e) => {
    const selected = Array.from(e.target.selectedOptions, option => option.value);
    setFormData(prev => ({ ...prev, CourseTypeID: selected }));

    if (selected.length > 0) {
      try {
        const res = await axios.get(`/api/course/nextId/${selected[0]}`);
        setFormData(prev => ({ ...prev, CourseID: res.data.nextId }));
      } catch (err) {
        console.error(err);
      }
    } else {
      setFormData(prev => ({ ...prev, CourseID: "" }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData(prev => ({
        ...prev,
        [parent]: { ...prev[parent], [child]: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const resetForm = () => {
    setFormData({
      CourseID: "",
      CourseName: "",
      CourseTypeID: [],
      duration: { value: 0, unit: "Months" },
      payment: { single: 0, installment: 0 },
    });
    setIsEdit(false);
    setEditingCourseId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!isEdit) {
        await axios.post("/api/course", formData);
        alert("Course added successfully!");
      } else {
        await axios.put(`/api/course/${editingCourseId}`, formData);
        alert("Course updated!");
      }
      resetForm();
      const res = await axios.get("/api/new/courses");
      setCourses(res.data || []);
    } catch (err) {
      console.error(err);
      alert("Submit failed.");
    }
  };

  const handleEdit = (course) => {
    setFormData({
      CourseID: course.CourseID,
      CourseName: course.CourseName,
      CourseTypeID: course.CourseTypeID.map(t => typeof t === "object" ? t._id : t),
      duration: course.duration || { value: 0, unit: "Months" },
      payment: course.payment || { single: 0, installment: 0 },
    });
    setIsEdit(true);
    setEditingCourseId(course._id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this course?")) return;
    try {
      await axios.delete(`/api/course/${id}`);
      setCourses(prev => prev.filter(c => c._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  const filteredCourses = courses.filter(c =>
    c.CourseName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalPages = Math.ceil(filteredCourses.length / itemsPerPage);
  const displayed = filteredCourses.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <div className="container mt-4">
      <h3 className="mb-4">{isEdit ? "Edit Course" : "Add Course"}</h3>
      <form onSubmit={handleSubmit} className="border p-4 rounded bg-light">
        
        {/* Course ID */}
        <div className="mb-3">
          <label className="form-label">Course ID</label>
          <input
            type="text"
            name="CourseID"
            value={formData.CourseID}
            readOnly
            className="form-control"
          />
        </div>

        {/* Course Type */}
        <div className="mb-3">
          <label className="form-label">Course Type</label>
          <select
            multiple
            name="CourseTypeID"
            value={formData.CourseTypeID}
            onChange={handleCourseTypeSelect}
            className="form-select"
            size={4}
          >
            {allCourseTypes.map(type => (
              <option key={type._id} value={type._id}>
                {type.CourseTypeName}
              </option>
            ))}
          </select>
        </div>

        {/* Course Name */}
        <div className="mb-3">
          <label className="form-label">Course Name</label>
          <input
            type="text"
            name="CourseName"
            value={formData.CourseName}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter course name"
          />
        </div>

        {/* Duration */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Duration</label>
            <input
              type="number"
              name="duration.value"
              value={formData.duration.value}
              onChange={handleChange}
              min={0}
              className="form-control"
              placeholder="Enter duration"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Unit</label>
            <select
              name="duration.unit"
              value={formData.duration.unit}
              onChange={handleChange}
              className="form-select"
            >
              <option value="Months">Months</option>
              <option value="Days">Days</option>
            </select>
          </div>
        </div>

        {/* Payment */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Single Payment (₹)</label>
            <input
              type="number"
              name="payment.single"
              value={formData.payment.single}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Installment (₹)</label>
            <input
              type="number"
              name="payment.installment"
              value={formData.payment.installment}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="mb-3">
          <button type="submit" className="btn btn-primary me-2">
            {isEdit ? "Update Course" : "Add Course"}
          </button>
          {isEdit && (
            <button type="button" onClick={resetForm} className="btn btn-secondary">
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* Search */}
      <div className="mt-4 mb-3">
        <input
          type="text"
          value={searchQuery}
          onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
          placeholder="Search Courses"
          className="form-control"
        />
      </div>

      {/* Table */}
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Course ID</th>
            <th>Name</th>
            <th>Type(s)</th>
            <th>Duration</th>
            <th>Payment</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
         {displayed?.map(course => (
  <tr key={course._id}>
    <td>{course?.CourseID || 'N/A'}</td>
    <td>{course?.CourseName || 'N/A'}</td>
    <td>
      {Array.isArray(course?.CourseTypeID) && course.CourseTypeID.length > 0
        ? course.CourseTypeID.map(type => type?.CourseTypeName || 'N/A').join(", ")
        : 'N/A'}
    </td>
    <td>
      {course?.duration?.value ? `${course.duration.value} ${course.duration.unit || ''}` : 'N/A'}
    </td>
    <td>
      ₹{course?.payment?.single ?? '0'}, ₹{course?.payment?.installment ?? '0'}
    </td>
    <td>
      <button onClick={() => handleEdit(course)} className="btn btn-sm btn-warning me-2">Edit</button>
      <button onClick={() => handleDelete(course._id)} className="btn btn-sm btn-danger">Delete</button>
    </td>
  </tr>
))}

          {displayed.length === 0 && (
            <tr><td colSpan={6} className="text-center">No courses found.</td></tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center align-items-center gap-3">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(p => p - 1)}
            className="btn btn-outline-secondary btn-sm"
          >
            « Prev
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(p => p + 1)}
            className="btn btn-outline-secondary btn-sm"
          >
            Next »
          </button>
        </div>
      )}
    </div>
  );
};

export default CourseManagement;
